import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'core-js/features/array';
import 'core-js/features/number';
import 'core-js/features/object';
import React from 'react';
import ReactDOM from 'react-dom';
import 'react-table/react-table.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

// eslint-disable-next-line no-undef
ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
